import { render, staticRenderFns } from "./RestaurantProfileComponent.vue?vue&type=template&id=bc3aff82&scoped=true&"
import script from "./RestaurantProfileComponent.vue?vue&type=script&lang=js&"
export * from "./RestaurantProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantProfileComponent.vue?vue&type=style&index=0&id=bc3aff82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3aff82",
  null
  
)

export default component.exports